import axios from 'axios';

const batchAxios = axios.create({
    baseURL: 'https://iuyum-batch.aysbulut.com/api/',
    headers: {
        'Content-Type': 'application/json'
    }
});

export default batchAxios;
